/* global localData */
function setLikeButtonsEvents() {
  const likeBtns = document.querySelectorAll('.count-card__like-btn');
  likeBtns.forEach((likeBtn) => {
    likeBtn.addEventListener('click', () => {
      const request = new XMLHttpRequest();
      request.open('POST', localData.siteURL, true);
      request.setRequestHeader('Content-Type', 'application/x-www-form-urlencoded; charset=UTF-8');
      request.send(`action=setShareNumber&nonce=${localData.nonce}&id=${likeBtn.closest('article').getAttribute('data-id')}`);
      request.onreadystatechange = function () {
        if (this.readyState === 4 && this.status === 200) {
          const response = JSON.parse(this.responseText);
          if (response.data.status === 200) {
            const sharedLike = likeBtn.closest('.count-card__like-btn');
            sharedLike.classList.add('is-liked');
            sharedLike.querySelector('span').innerHTML = response.data.number;
          }
        }
      };
    });
  });
}
if (document.querySelector('.main.filters-page, .main.landing-page')) {
  // eslint-disable-next-line no-undef
  const isotope = new Isotope('.count-list-grid', {
    itemSelector: '.count-card',
  });
  const isotopeBtns = document.querySelectorAll('.link-filter__inner .tab-categories');
  isotopeBtns.forEach((isotopeBtn) => {
    isotopeBtn.addEventListener('click', () => {
      const isotopeBtnData = isotopeBtn.getAttribute('data-filter');
      isotope.arrange({ filter: isotopeBtnData });
      isotopeBtns.forEach((activeBtn) => {
        activeBtn.classList.remove('is-active');
      });
      isotopeBtn.classList.add('is-active');
    });
  });
  setLikeButtonsEvents();
} else if (document.querySelector('.sc-count-slider, .sc-image-text')) {
  setLikeButtonsEvents();
}
